export type CustomerCategory =
  | "在线教育"
  | "零售与消费"
  | "金融与科技"
  | "本地生活";

export type CustomerLogoItem = {
  filename: string;
  name: string;
  category: CustomerCategory;
  /** 客户案例博客 slug；有值则可点击跳转 */
  blogSlug?: string;
  /** 仅在对应解决方案页展示，首页 logo 墙不展示 */
  solutionOnly?: boolean;
};

/** 按设计稿顺序排列 */
export const customerLogos: CustomerLogoItem[] = [
  { filename: "bytedance.svg", name: "字节跳动", category: "金融与科技" },
  {
    filename: "xiaopeng.svg",
    name: "小鹏汽车",
    category: "零售与消费",
    blogSlug: "3chat-ai-new-customer-xpeng",
  },
  { filename: "Insta360.svg", name: "影石 Insta360", category: "零售与消费" },
  { filename: "Xiaomi.svg", name: "小米汽车", category: "零售与消费" },
  {
    filename: "gaotu.svg",
    name: "高途教育",
    category: "在线教育",
    blogSlug: "3chat-ai-new-customer-gaotujiaoyu",
  },
  { filename: "sibionics.svg", name: "硅基仿生", category: "零售与消费" },
  {
    filename: "Passion Propels.svg",
    name: "小极研造",
    category: "本地生活",
    blogSlug: "3chat-ai-customer-service-custom-furniture-client-case-study",
  },
  { filename: "AGIBOT.svg", name: "智元机器人", category: "零售与消费" },
  { filename: "Dirct Drive Tech.svg", name: "本末科技", category: "零售与消费" },
  {
    filename: "Fibocom.svg",
    name: "广和通 Fibocom",
    category: "金融与科技",
    blogSlug: "3chat-ai-new-customer-guanghetong",
  },
  { filename: "MINISFORUM.svg", name: "铭凡", category: "零售与消费" },
  { filename: "千里马.svg", name: "千里马", category: "金融与科技" },
  { filename: "iHerb.svg", name: "iHerb", category: "零售与消费" },
  { filename: "惠达科技.svg", name: "惠达科技", category: "零售与消费" },
  { filename: "xvessel.svg", name: "xVESSEL", category: "零售与消费" },
  {
    filename: "youshixingqiu.svg",
    name: "优势星球",
    category: "在线教育",
    blogSlug: "leading-education-brand-ai-sales-agent-case-study",
  },
  { filename: "cornet.svg", name: "Carnet.车脉", category: "零售与消费" },
  { filename: "Hengli.svg", name: "恒立液压", category: "金融与科技" },
  {
    filename: "shopline.svg",
    name: "Shopline",
    category: "金融与科技",
    blogSlug: "shopline-x-3chat-customer-story",
  },
  { filename: "talentsAI.svg", name: "TalentsAI", category: "金融与科技" },
  {
    filename: "cooktime.svg",
    name: "酷太",
    category: "本地生活",
    blogSlug: "3chat-ai-customer-service-custom-furniture-client-case-study",
  },
  {
    filename: "beisen.svg",
    name: "北森",
    category: "金融与科技",
    blogSlug: "3chat-ai-new-customer-beisen",
  },
  { filename: "PERODUA.svg", name: "派乐多", category: "零售与消费" },
  { filename: "xingchangxinda.svg", name: "兴长信达", category: "本地生活" },
  {
    filename: "mofangyundong.svg",
    name: "魔方运动",
    category: "本地生活",
    solutionOnly: true,
  },
];

/** 大屏每行 4 个，首页只展示能凑满整行的 logo */
export const LOGOS_PER_ROW = 4;

export function getCustomerLogos(category?: CustomerCategory): CustomerLogoItem[] {
  if (!category) {
    const homepageLogos = customerLogos.filter((item) => !item.solutionOnly);
    return homepageLogos.slice(
      0,
      Math.floor(homepageLogos.length / LOGOS_PER_ROW) * LOGOS_PER_ROW,
    );
  }
  return customerLogos.filter((item) => item.category === category);
}
